module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_SKU2.0045.png.0ca2b568.jpg";